import { CommonHttpHelper, NO_DATA_MESSAGE, BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const postProcessLearnToSwimBulkImportIds = (learnToSwimArray, state, setState) => {
  if (state.isSaving !== true && Array.isArray(learnToSwimArray) && !state.message) {
    let newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const url = `/LearnToSwimProvider/Import`;
    CommonHttpHelper(url, 'POST', learnToSwimArray)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          };
          setState(newState);
        }

      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

const LearnToSwimBulkImportUploadData = { INITIAL_STATE: BASIC_INITIAL_STATE, postProcessLearnToSwimBulkImportIds };

export default LearnToSwimBulkImportUploadData;

